import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router'
import { connect } from 'react-redux'
import { compact } from 'lodash'

import { interleave } from 'utils/array'
import { Paths } from 'utils/paths'
import UniversalHelpButton from 'components/Elements/UniversalHelpButton'


class Breadcrumbs extends React.PureComponent {
  static propTypes = {
    currentUsername: PropTypes.string,
    urlUsername: PropTypes.string,
    breadcrumbs: PropTypes.shape({
      set: PropTypes.bool.isRequired,
      options: PropTypes.shape({
        title: PropTypes.string,
        children: PropTypes.arrayOf(PropTypes.shape({
          to: PropTypes.string,
          label: PropTypes.string
        })),
        noHelp: PropTypes.bool,
      })
    })
  }

  userLink() {
    const { currentUsername, urlUsername } = this.props

    if (currentUsername && urlUsername) {
      // logged in and visiting a username-prefixed route
      const
        path = (urlUsername === currentUsername)
          ? Paths.profile // own resource, link to own, protected profile
          : Paths.public_user // viewing another user's resource, link to their public profile

      // draw and link to url username
      return { to: path({ username: urlUsername }), label: urlUsername }

    } else if (urlUsername) {
      // not logged in
      // NOTE: why not linking to public profile here?
      return { label: urlUsername }

    } else if (currentUsername) {
      // logged in at a non-user-prefixed url
      return { to: Paths.profile({ username: currentUsername }), label: currentUsername }
    }
  }

  renderCrumbs() {
    const
      // gather every crumb as { to:, label: } objects
      { children=[], title } = this.props.breadcrumbs.options,
      titleObject = title && { label: title },
      userObject = this.userLink(),
      separator = { label: " / " },

      crumbs = interleave( // insert separators between each
        compact([ // toss missing items
          userObject,
          ...children,
          titleObject
        ]),
        separator
      )

    // map them to spans and links
    return crumbs.map(({ to, label }, idx) =>
      to
        ? <Link key={ idx } to={ to }>{ label }</Link>
        : <span key={ idx } className='title'>{ label }</span>
    )
  }

  render() {
    if (!this.props.breadcrumbs.set) { return null }

    const
      { noHelp } = this.props.breadcrumbs.options,
      breadcrumbLinks = this.renderCrumbs()

    return (
      <div className="breadcrumbs">
        <div className="container hidden-xs">
          <div className="row">
            <div className="col-sm-9 content">
              { breadcrumbLinks }
            </div>

            <div className="col-sm-3 help">
              { !noHelp && <UniversalHelpButton /> }
            </div>
          </div>
        </div>

        <div className="container hidden-sm visible-xs mobile">
          <div className="row">
            <div className="col-xs-12">
              <div className="content">
                { breadcrumbLinks }
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapState = state => ({
  breadcrumbs: state.breadcrumbs
})

const ConnectedBreadcrumbs = connect(mapState)(Breadcrumbs)
export default ConnectedBreadcrumbs
